import { BadgeSearchableSelect } from "@spz/ui/components/badge-searchable-select";
import { SearchableSelect } from "@spz/ui/components/searchable-select";
import { Separator } from "@spz/ui/components/separator";
import { useTranslation } from "react-i18next";
import { useMainControlFiltersStore } from "../stores/main-control-filters.store";

export const ControlListMainFilters = () => {
  const { t } = useTranslation();
  const {
    methods,
    availableCompanies,
    selectedCompanyId,
    selectedAnalysisId,
    selectedPeriodId,
    availablePeriods,
    availableAnalyses,
  } = useMainControlFiltersStore();
  return (
    <div className="gap-4 flex flex-wrap">
      <SearchableSelect
        placeholder={t("company")}
        className="md:w-auto lg:w-[180px] xl:w-[200px]"
        options={availableCompanies}
        onSelect={methods.setSelectedCompanyId}
        value={selectedCompanyId ? [selectedCompanyId] : []}
        variant="ghost"
        dataTestId="control-list-company-dropdown"
        searchInputTestId="control-list-company-search-input"
      />
      <Separator orientation="vertical" className="h-3 lg:block hidden" />
      <SearchableSelect
        placeholder={t("period")}
        className="md:w-auto lg:w-[200px] xl:w-[260px]"
        options={availablePeriods}
        onSelect={methods.setSelectedPeriodId}
        value={selectedPeriodId ? [selectedPeriodId] : []}
        variant="ghost"
      />
      <Separator orientation="vertical" className="h-3 lg:block hidden" />
      <BadgeSearchableSelect
        placeholder={t("analysis")}
        className="md:w-auto lg:w-[200px] xl:w-[260px]"
        options={availableAnalyses}
        onSelect={methods.setSelectedAnalysisId}
        value={selectedAnalysisId ? [selectedAnalysisId] : []}
        variant="ghost"
      />
    </div>
  );
};
